<template>
	<vx-card>
		<div class="vx-col">
			<div class="vx-row">
				<div class="vx-col sm:w-1/2 w-full mb-2">
					<h3>Ajouter un contact</h3>
				</div>
				<div class="vx-col sm:w-1/2 w-full mb-2">
					<vs-button
						class="float-right"
						radius
						color="primary"
						type="filled"
						icon-pack="feather"
						icon="icon-x"
						@click="returnPrevRoute"
					></vs-button>
				</div>
			</div>
			<div class="vx-row w-full">
				<div class="vx-col">
					<vue-simple-suggest
						:disabled="userIsSelected || userCreation || userEmailErr"
						pattern="\w+"
						v-model.lazy="userMail"
						:list="users"
						:max-suggestions="10"
						:min-length="1"
						:debounce="200"
						:filter-by-query="true"
						:prevent-submit="true"
						mode="input"
						:nullable-select="true"
						ref="suggestComponent"
						placeholder="Email"
						value-attribute="email"
						display-attribute="email"
						style="border: 0"
					>
						<template slot="misc-item-above" slot-scope="{ suggestions }">
							<template v-if="suggestions.length <= 0"> </template>
						</template>

						<div
							slot="suggestion-item"
							slot-scope="scope"
							:title="scope.suggestion.description"
						>
							<div class="text">
								<span v-html="boldenSuggestion(scope)"></span>
							</div>
						</div>
					</vue-simple-suggest>
				</div>
				<div
					class="vx-col"
					style="display: flex; align-items: center; justify-content: center"
				>
					<vs-button
						v-if="userIsSelected || userCreation || userEmailErr"
						color="primary"
						type="border"
						class="mb-2 mr-3"
						@click="unselectContact"
						>Desélectionner le contact</vs-button
					>
					<vs-button
						v-else
						color="primary"
						type="border"
						class="mb-2 mr-3"
						@click="selectContact"
						>Vérifier si le contact existe</vs-button
					>
				</div>
				<div class="vx-col">
					<strong v-if="userIsSelected"
						>Le contact a bien été sélectionné. Remplissez les champs
						manquants.</strong
					>
					<strong v-if="userCreation"
						>Aucun contact n'a été trouvé. Veuillez créer le contact.</strong
					>
					<strong v-if="userEmailErr"
						>L'adresse mail saisie n'est pas valide.</strong
					>
				</div>
			</div>
			<span v-if="userIsSelected || userCreation">
				<hr class="mt-2" />
				<div
					class="vx-row w-1/4 mt-8"
					style="display: block; white-space: nowrap"
				>
					<div class="vx-col sm:w-1/2 w-full mb-2 inlineB">
						<vs-radio
							v-model="contact.civility"
							vs-name="Madame"
							vs-value="1"
							class="mr-4"
							:disabled="userIsSelected"
							>Madame</vs-radio
						>
					</div>
					<div class="vx-col sm:w-1/2 w-full mb-2 inlineB">
						<vs-radio
							v-model="contact.civility"
							vs-name="Monsieur"
							vs-value="2"
							:disabled="userIsSelected"
							>Monsieur</vs-radio
						>
					</div>
					<vx-tooltip
						v-if="
							validators['civility'] && validators['civility'].errText !== ''
						"
						:text="errText('civility')"
						class="ml-3 inlineB"
					>
						<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
					</vx-tooltip>
				</div>
				<div class="vx-row mt-4">
					<div
						class="vx-col sm:w-1/2 w-full mb-2 flex"
						v-if="$route.params.societyId"
					>
						<vx-input-group class="w-full bottom">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="domain" size="small"></vs-icon
									></span>
								</div>
							</template>
							<vs-select
								autocomplete
								v-model="contact.societies_id"
								class="w-1/2 select-large"
								placeholder="Société"
								disabled
							>
								<vs-select-item
									:key="index"
									:value="item.id"
									:text="item.name"
									v-for="(item, index) in societyOptions"
									class="w-full"
								/>
							</vs-select>
						</vx-input-group>
					</div>
				</div>
				<div class="vx-row mt-5">
					<div class="vx-col sm:w-1/2 w-full mb-2" style="white-space: nowrap">
						<!-- FIRST NAME -->
						<vx-input-group class="w-full bottom">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="person" size="small"></vs-icon
									></span>
								</div>
							</template>
							<vs-input
								:style="styleValidator('firstname')"
								class="w-full"
								placeholder="Prénom"
								v-model="contact.firstname"
								:disabled="userIsSelected"
								@change="validateOne(contact.firstname, 'firstname')"
							/>
						</vx-input-group>
						<vx-tooltip
							v-if="
								validators['firstname'] &&
								validators['firstname'].errText !== ''
							"
							:text="errText('firstname')"
							class="ml-3 inlineB"
						>
							<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
						</vx-tooltip>
						<!-- /FIRST NAME -->
					</div>
					<div class="vx-col sm:w-1/2 w-full mb-2" style="white-space: nowrap">
						<!-- LAST NAME -->
						<vx-input-group class="w-full bottom">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="person" size="small"></vs-icon
									></span>
								</div>
							</template>
							<vs-input
								:style="styleValidator('lastname')"
								class="w-full"
								placeholder="Nom"
								v-model="contact.lastname"
								:disabled="userIsSelected"
								@change="validateOne(contact.lastname, 'lastname')"
							/>
						</vx-input-group>
						<vx-tooltip
							v-if="
								validators['lastname'] && validators['lastname'].errText !== ''
							"
							:text="errText('lastname')"
							class="ml-3 inlineB"
						>
							<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
						</vx-tooltip>
						<!-- /LAST NAME -->
					</div>
				</div>
				<div class="vx-row mt-5">
					<div
						class="vx-col sm:w-1/2 w-full mb-2 flex"
						style="white-space: nowrap"
					>
						<!-- PHONE -->
						<vx-input-group class="w-full bottom">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="local_phone" size="small"></vs-icon
									></span>
								</div>
							</template>

							<!-- <vs-input
              v-model="contact.phone"
              :disabled="userIsSelected"
              placeholder="Téléphone"
              :danger="ContactValidationObjects.phoneValidationObject.notValid"
              :danger-text="ContactValidationObjects.phoneValidationObject.errText"
            /> -->
							<vs-input
								:style="styleValidator('phone')"
								v-model="contact.phone"
								class="w-full"
								:disabled="userIsSelected"
								placeholder="Téléphone"
								@change="validateOne(contact.phone, 'phone')"
							/>
						</vx-input-group>
						<vx-tooltip
							v-if="validators['phone'] && validators['phone'].errText !== ''"
							:text="errText('phone')"
							class="ml-3 inlineB"
						>
							<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
						</vx-tooltip>
						<!-- /PHONE -->
					</div>
					<div
						class="vx-col sm:w-1/2 w-full mb-2"
						v-if="this.$route.params.societyId"
					>
						<!-- FONCTION -->
						<vx-input-group class="w-full bottom">
							<template slot="prepend">
								<div class="prepend-text bg-primary">Fonction</div>
							</template>
							<vs-input
								class="w-full"
								placeholder="Fonction du contact (PDG, Directeur marketing...)"
								v-model="contact.fonction"
							/>
						</vx-input-group>
						<!-- /FONCTION -->
					</div>
				</div>
				<div class="vx-row">
					<div class="vx-col sm:w-1/2 w-full mb-2" style="white-space: nowrap">
						<vs-select
							autocomplete
							v-model="contact.type"
							class="w-1/2 select-large mt-4"
							label="Type de contact"
							@change="validateOne(contact.type, 'type')"
							style="display: inline-block"
						>
							<vs-select-item
								:key="index"
								:value="item.value"
								:text="item.text"
								v-for="(item, index) in typeOptions"
								class="w-full"
							/>
						</vs-select>
						<vx-tooltip
							v-if="validators['type'] && validators['type'].errText !== ''"
							:text="errText('type')"
							class="ml-3 inlineB"
						>
							<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
						</vx-tooltip>
					</div>
					<vs-checkbox class="inline-flex mt-4" v-model="contact.hasAccess"
						>Accès au dashboard</vs-checkbox
					>
				</div>
				<div class="vx-row right_element">
					<div class="vx-col">
						<vs-button
							color="warning"
							type="border"
							class="mb-2 mr-3"
							@click="resetFields"
							>Réinitialiser</vs-button
						>
						<vs-button v-if="isLoading">Chargement ...</vs-button>
						<vs-button v-else class="mb-2" @click="validateAll"
							>Ajouter</vs-button
						>
					</div>
				</div>
			</span>
		</div>
	</vx-card>
</template>

<script>
import { Contact } from "@/entities/Contact";
import Validator from "@/entities/Validator";
import utilsMixin from "@/mixins/utilsMixin";
import validatorMixin from "@/mixins/validatorMixin";
import "vue-simple-suggest/dist/styles.css";
import VueSimpleSuggest from "vue-simple-suggest";

import store from "@/store/store";
import VxTooltip from "./../../../components/widgets/vx-tooltip/VxTooltip.vue";

export default {
	name: "ContactForm",
	props: {
		chartParams: Object,
		isPercent: Boolean,
	},
	components: {
		VueSimpleSuggest,
		VxTooltip,
	},
	mixins: [utilsMixin, validatorMixin],
	data() {
		return {
			// USER OBJECT
			contact: Contact.getFormFields(),
			selectedUser: null,
			userMail: null,
			userIsSelected: false,
			userCreation: false,
			userEmailErr: false,
			apiUrl: this.$store.state.backendApiUrl,
			// FORM SELECT OPTIONS
			typeOptions: [
				{ text: "Facturation", value: 1 },
				{ text: "Commercial", value: 2 },
				{ text: "Technique", value: 5 },
				{ text: "Collaborateur externe", value: 7 },
			],
			societyOptions: new Array(),
			// CONTACT VALIDATORS
			ContactValidationObjects: {
				civilityValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "civilityConstraint",
					required: true,
				},
				firstnameValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "firstnameConstraint",
					required: true,
				},
				lastnameValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "lastnameConstraint",
					required: true,
				},
				typeValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "typeConstraint",
					required: true,
				},
				emailValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "emailConstraint",
					required: true,
				},
				/*
				 * phoneValidationObject: {
				 *   valid: false,
				 *   notValid: false,
				 *   validText: null,
				 *   errText: null,
				 *   constraintName: "phoneConstraint",
				 *   required: true
				 * },
				 */
				hasAccessValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "hasAccessConstraint",
					required: true,
				},
			},
			validators: {},
			check: true,
		};
	},
	computed: {
		users: () => {
			return store.state.users;
		},
	},
	created() {
		this.getAllUsers();
		this.getAllSocieties();
		this.contact.societies_id = this.$route.params.societyId;
	},
	beforeUnmount() {
		// Find and remove any lingering tooltip elements
		const tooltips = document.querySelectorAll(".vx-tooltip-content");
		tooltips.forEach((tooltip) => tooltip.remove());
	},
	methods: {
		boldenSuggestion(scope) {
			if (!scope) return scope;
			const { suggestion, query } = scope;
			let result = this.$refs.suggestComponent.displayProperty(suggestion);
			if (!query) return result;
			const texts = query.split(/[\s-_/\\|.]/gm).filter((t) => !!t) || [""];
			return result.replace(
				new RegExp("(.*?)(" + texts.join("|") + ")(.*?)", "gi"),
				"$1<b>$2</b>$3"
			);
		},

		selectContact() {
			// Si le mail existe dans la liste sélectionner le client en remplissant les champs AFFICHES, SAUF TYPE qui lui peut changer
			if (this.userMail == "") {
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez saisir une adresse mail.",
				});
			} else {
				this.validators["email"] = new Validator({
					constraintName: "emailConstraint",
				});
				this.validators["email"].check(this.userMail);
				if (this.validators["email"].valid == false) {
					//console.log("errrr");
					this.check = false;
					this.userEmailErr = true;
				} else {
					let foundUser = this.users.filter(
						(user) => user.email === this.userMail
					);
					if (foundUser.length > 0) {
						//console.log(foundUser);
						this.selectedUser = foundUser[0];
						this.contact.civility = this.selectedUser.civility;
						this.contact.firstname = this.selectedUser.firstname;
						this.contact.lastname = this.selectedUser.lastname;
						this.contact.phone = this.selectedUser.phone;
						this.contact.hasAccess = this.selectedUser.hasAccess;
						//Active le booléen pour bloquer les modifications et à l'enregistrement ne pas créer de nouvel utilisateur
						this.userIsSelected = true;
					} else {
						this.userCreation = true;
					}
				}
			}
		},

		unselectContact() {
			this.userIsSelected = false;
			this.userCreation = false;
			this.userEmailErr = false;
		},

		/**
		 * Query our Api to fetch all societies for societyOptions used in form
		 */
		getAllSocieties() {
			this.$http
				.get(this.apiUrl + "society/all")
				.then((res) => {
					this.societyOptions = res.data;
				})
				.catch((err) => {
					console.error(err);
				});
		},

		/**
		 * Query our Api to fetch all users
		 */
		getAllUsers() {
			this.$store.dispatch("getAllUsers");
		},

		validateOne(val, name) {
			let value = val;
			value == 0 ? (value = "0") : "";
			let constname = name + "Constraint";
			this.validators[name] = new Validator({ constraintName: constname });
			this.validators[name].check(value);
			this.validators[name].errText == "" &&
			this.validators[name].valid == false
				? (this.validators[name].errText = "Ce champ ne peut être vide.")
				: "";
			this.validators[name].valid == false ? (this.check = false) : "";
			this.$forceUpdate();
		},
		errText(name) {
			if (this.validators[name] && this.validators[name].errText !== "") {
				return this.validators[name].errText;
			}
		},
		styleValidator(name) {
			if (this.validators[name] && this.validators[name].valid == false) {
				if (name == "type") {
					return "border: 1px solid red !important; border-radius: 5px 5px 5px 5px;";
				} else {
					return "border: 1px solid red !important; border-radius: 0 5px 5px 0;";
				}
			} else if (this.validators[name] && this.validators[name].valid == true) {
				if (name == "type") {
					return "border: 1px solid green !important; border-radius: 5px 5px 5px 5px;";
				} else {
					return "border: 1px solid green !important; border-radius: 0 5px 5px 0;";
				}
			} else {
			}
		},
		async validateAll() {
			this.isLoading = true;
			this.check = true;
			let fields = ["firstname", "lastname", "civility", "phone", "type"];

			if (!this.contact.firstname) this.contact.firstname = "Inconnu";
			if (!this.contact.lastname) this.contact.lastname = "Inconnu";
			if (!this.contact.phone) this.contact.phone = "0000000000";

			for (let i = 0; i < fields.length; i++) {
				let name = fields[i] + "Constraint";
				let value = this.contact[fields[i]];
				value == 0 ? (value = "0") : "";
				this.validators[fields[i]] = new Validator({ constraintName: name });
				this.validators[fields[i]].check(value);
				this.validators[fields[i]].errText == "" &&
				this.validators[fields[i]].valid == false
					? (this.validators[fields[i]].errText = "Ce champ ne peut être vide.")
					: "";
				this.validators[fields[i]].valid == false ? (this.check = false) : "";
				this.$forceUpdate();
			}
			this.check == true ? await this.formSubmitted() : "";
			this.isLoading = false;
		},

		/**
		 * Send the data to tha API to create the new user
		 * If the form is successfully sent, the user is redirect to Client.vue
		 */
		async formSubmitted() {
			let relAction = "";
			let relParam = {};
			let userParam = {};

			relAction = this.$route.params.societyId
				? "usersSocieties/new"
				: "usersProviders/add";
			relAction = this.userIsSelected ? relAction : relAction + "m"; // If user is not selected add relation by mail

			relParam["type"] = this.contact.type;

			if (this.$route.params.societyId) {
				relParam["society_id"] = this.contact.societies_id;
				relParam["fonction"] = this.contact.fonction;
			}

			if (this.$route.params.providerId)
				relParam["provider_id"] = this.$route.params.providerId;

			if (this.userIsSelected) relParam["users_id"] = this.selectedUser.id;
			else relParam["email"] = this.userMail;
			/*
			 * {
			 *     society_id: this.contact.societies_id,
			 *     email: this.userMail,
			 *     type: this.contact.type
			 *     }
			 */
			//console.log(relParam);
			if (this.userIsSelected) {
				let user = this.contact;
				user.email = this.userMail;
				user.id = this.selectedUser.id;
				if (this.contact.type == 7 && this.contact.role == 2) {
					//console.log("New Extern");
					user.role = 1;
					user.hasAccess = 1;
					await this.$http.post(this.apiUrl + "users/update", {
						user,
					});
					//console.log("New Extern OK");
				} else {
					//console.log("Update Contact");
					await this.$http.post(this.apiUrl + "users/updatec", {
						user,
					});
				}
				//console.log("User Relation", relAction, relParam);
				// Création de la relation user - society
				this.$http
					.post(this.apiUrl + relAction, relParam)
					.then(() => {
						//console.log("User Relation", relAction, relParam, "DONE");
						this.$vs.notify({
							title: "Succès",
							text: "Contact ajouté avec succès.",
						});
						this.$router.go(-1);
						// if(this.$route.params.societyId){
						// 	let mailList = {
						// 		new_society: false,
						// 		mail_list: [
						// 			{
						// 				email: this.userMail,
						// 				type: this.contact.type
						// 			}
						// 		],
						// 		mails: [
						// 			this.userMail
						// 		],
						// 		society_id: this.$route.params.societyId
						// 	};
						// 	this.$http.post(this.apiUrl + "usersSocieties/update/qb/mail", mailList)
						// 		.then(result => {
						// 			//console.log("update/qb/mail", mailList);
						// 			this.$router.go(-1);
						// 		})
						// 		.catch(err => {
						// 			this.$vs.notify({
						// 				title: err[0],
						// 				text: err[err.length - 1]
						// 			});
						// 		});
						// }
						// else{
						// 	this.$router.go(-1);
						// }
					})
					.catch((err) => {
						//console.log(err);
						this.$vs.notify({
							title: "Erreur",
							text: "Le contact n'a pas été ajouté.",
						});
					});
			} else {
				let role = 2;
				if (this.contact.type == 7) role = 1;
				// Création de l'utilisateur
				//console.log(this.userMail);
				this.$http
					.post(this.apiUrl + "users/new", {
						email: this.userMail,
						password: true,
						firstname: this.contact.firstname,
						lastname: this.contact.lastname,
						role: role,
						phone: this.contact.phone,
						image_url: this.contact.image_url,
						commentary: this.contact.commentary,
						status: this.contact.status,
						type: this.contact.type,
						civility: this.contact.civility,
						hasAccess: this.contact.hasAccess,
						societies_id: this.contact.societies_id,
					})
					.then((res) => {
						// Création de la relation user - society
						this.$http
							.post(this.apiUrl + relAction, relParam)
							.then(() => {
								// if (this.$route.params.societyId) {
								// 	let mailList = {
								// 		new_society: false,
								// 		mail_list: [
								// 			{
								// 				email: this.userMail,
								// 				type: this.contact.type,
								// 			},
								// 		],
								// 		society_id: this.$route.params.societyId,
								// 	};
								// 	this.$http
								// 		.post(
								// 			this.apiUrl + "usersSocieties/update/qb/mail",
								// 			mailList
								// 		)
								// 		.then((result) => {
								// 			//console.log("usersSocieties/update/qb/mail", mailList);
								// 			this.$vs.notify({
								// 				title: "Succès",
								// 				text: "Contact ajouté avec succès.",
								// 			});
								// 			// Send the user to the previous route
								// 			this.$router.go(-1);
								// 		})
								// 		.catch((err) => {
								// 			this.$vs.notify({
								// 				title: err[0],
								// 				text: err[err.length - 1],
								// 			});
								// 		});
								// } else {
								// 	this.$vs.notify({
								// 		title: "Succès",
								// 		text: "Contact ajouté avec succès.",
								// 	});
								// 	// Send the user to the previous route
								// 	this.$router.go(-1);
								// }
								this.$router.go(-1);
							})
							.catch((err) => {
								//console.log(err);
								this.$vs.notify({
									title: "Erreur",
									text: "Le contact n'a pas été ajouté.",
								});
							});
					})
					.catch((err) => {
						//console.log(err);
						this.$vs.notify({
							title: "Erreur",
							text: "Le contact n'a pas été ajouté.",
						});
					});
			}
		},

		/**
		 * Checks if first name is valid
		 */
		checkFirstname() {
			this.checkHandler(
				this.contact.firstname,
				this.ContactValidationObjects.firstnameValidationObject
			);
		},
		/**
		 * Checks if last name is valid
		 */
		checkLastname() {
			this.checkHandler(
				this.contact.lastname,
				this.ContactValidationObjects.lastnameValidationObject
			);
		},

		/**
		 * Checks if email is valid
		 */
		checkEmail() {
			this.checkHandler(
				this.contact.email,
				this.ContactValidationObjects.emailValidationObject
			);
		},

		/**
		 * Checks if phone is valid
		 */
		checkPhone() {
			let phone = "";
			if (this.contact.phone) phone = this.contact.phone.split(" ").join("");
			this.checkHandler(
				phone,
				this.ContactValidationObjects.phoneValidationObject
			);
		},

		/**
		 * Checks if type is valid
		 */
		checkType() {
			this.checkHandler(
				this.contact.type,
				this.ContactValidationObjects.typeValidationObject
			);
		},

		/**
		 * Check if all required fields for Contact are valid
		 * @return true if all are valid else return false if at least one is not valid
		 */
		checkAllRequiredContactFields() {
			let requiredFieldsOk = true;

			Object.entries(this.ContactValidationObjects).forEach((entry) => {
				const [key, value] = entry;
				if (value.required && !value.valid && requiredFieldsOk) {
					requiredFieldsOk = value.valid;
				}
			});

			return requiredFieldsOk;
		},
		resetFields() {
			this.resetForm(this.contact);
			this.checkType();
			// this.checkPhone()
			this.checkEmail();
			this.checkLastname();
			this.checkFirstname();
		},

		/**
		 * Redirect to the previous page
		 */
		returnPrevRoute() {
			this.$router.go(-1);
		},
	},
};
</script>

<style scoped>
.inlineB {
	display: inline-block;
}

.role_selector_container {
	justify-content: space-between;
	width: 40%;
}

.role_container {
	justify-content: center;
}

.space_div {
	margin: 5px;
}

.bottom {
	align-self: flex-end;
}

.center {
	align-self: center;
}

.right_element {
	justify-content: flex-end;
}
</style>
